export default __webpack_public_path__ + "static/media/skippedmeal@2x.6fc9faad.jpg";